import {
  SearchVolumeEstimation,
  SearchWarmupParams,
  WarmupAPI,
} from "@radarly/api/warmups";
import { SearchData, SearchParams } from "@radarly/models/search";
import { WarmupRepository } from "./WarmupRepository";

interface Dependencies {
  warmupAPI: WarmupAPI;
}

export class APIWarmupRepository implements WarmupRepository {
  private warmupAPI: WarmupAPI;
  public constructor(dependencies: Dependencies) {
    this.warmupAPI = dependencies.warmupAPI;
  }
  public async searchHistorical(params: SearchWarmupParams) {
    return await this.warmupAPI.searchWarmups(params);
  }
  async searchFragmentData<T extends SearchData>(
    project: number,
    query: SearchParams
  ) {
    return await this.warmupAPI.searchWarmupPosts<T>(project, query);
  }
  public async retrieveData(projectId: number, params: SearchWarmupParams) {
    return await this.warmupAPI.retrieveData(projectId, params);
  }
  public async getHistoricals(projectId: number) {
    return await this.warmupAPI.getHistoricals(projectId);
  }
  public async getHistoricalEstimation(
    projectId: number,
    params: SearchWarmupParams
  ): Promise<SearchVolumeEstimation> {
    return await this.warmupAPI.getHistoricalEstimation(projectId, params);
  }
}
